export default __webpack_public_path__ + "static/avatar-mp-kayi-female-0-v4-cover-94532a2e69ecdfea0af85dc9dc74c9b1.png";